export default function () {
  let questions = document.querySelectorAll(".faq__question");

  if (!questions) {
    return;
  }
  for (let i = 0; i < questions.length; i++) {
    const element = questions[i];
    element.addEventListener("click", function () {
      handleTabClick(this);
    });
  }

  const handleTabClick = (e) => {
    if (e.classList.contains("active")) {
      e.classList.remove("active");
    } else {
      for (let i = 0; i < questions.length; i++) {
        const element = questions[i];
        element.classList.remove("active");
      }

      e.classList.add("active");
    }
  };
}
